import { render, staticRenderFns } from "./AgTable.vue?vue&type=template&id=391a2090"
import script from "./AgTable.vue?vue&type=script&lang=js"
export * from "./AgTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('391a2090')) {
      api.createRecord('391a2090', component.options)
    } else {
      api.reload('391a2090', component.options)
    }
    module.hot.accept("./AgTable.vue?vue&type=template&id=391a2090", function () {
      api.rerender('391a2090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ag-table/AgTable.vue"
export default component.exports